import { render, staticRenderFns } from "./TipoAquisicaoIBPList.vue?vue&type=template&id=3b06fa70"
import script from "./TipoAquisicaoIBPList.vue?vue&type=script&lang=js"
export * from "./TipoAquisicaoIBPList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports